import {Component} from "react";
import * as React from "react";
import {AccordionForm, BoxedSelectList, BoxedField, BoxedText, BoxedYesNo} from '..'
import {preloadImages} from 'helpers/ApplicationHelper';
import {browserHistory} from "react-router";
import I18n from 'lib/i18n/i18n';

/**
 * The following details come from the item_types and subset_types table.
 * @type {{subset_id: number, system_name: string, name: string, id: number, display_name: string}}
 */
const watch_details = {
    id: 3,
    name: "Luxury Watches",
    system_name: "luxury_watches",
    display_name: "Watches",
    subset_id: 11,
    subset_system_name: "luxury_watch_watches"
}


/**
 *  On first init of the submit form - update all constants from i18n
 */
let initialized = false
function init() {
    let brands = I18n.getVar("submitForm::watch::brandOptions")
    modelsByBrand = I18n.getVar("submitForm::watch::modelsByBrand")

    // create the brandOptions object. i18n turns the array to object with numerical indexes.
    // turn back to array.
    brandOptions = []
    for ( let brandIndex = 0 ; brandIndex < Object.keys(brands).length ; brandIndex++ ) {
        let brand = brands[brandIndex]
        brand.img = WATCH_ITEM_PREFIX + brand.name + ".png"
        brand.imgSelected = WATCH_ITEM_PREFIX + brand.name + "_white.png"
        brandOptions.push(brand)
    }

    // update conditions
    let conditions = I18n.getVar("submitForm::watch::conditions")
    for ( let condition in conditions ) {
        conditionOptions.push({name:condition,text:conditions[condition]})
    }

    // update options.
    formOptions.brand.options = brandOptions
}

class SubmitWatch extends Component {

    constructor(props) {
        super(props)

        // init strings.
        if ( !initialized ) {
            init()
            initialized = true
        }

        this.state = {
            options:[]
        }
        this.state.options = this.getOptions()

        // preload images - only brands have images for watch.
        preloadImages(preloads.map( name => WATCH_ITEM_PREFIX + name ))

        this.submitWatch = this.submitWatch.bind(this)
        this.onValueChanged = this.onValueChanged.bind(this)
    }

    submitWatch(details) {

        let params = {
            item_type: watch_details.display_name,
            returnToSite: true,
            seller_item: {
                item_type_id: watch_details.id,
                desc: watch_details.display_name,
                initial_transaction_type: 1,        // legacy. always one for watch
                subsets: {
                    1: {
                        type: watch_details.subset_system_name,
                        properties_set: {
                            item_type: watch_details.id
                        }
                    }
                }
            }
        }

        // normalize values for db.
        for ( let key in details ) {
            let isOther = this.isOtherSelected(key)

            // if user selected an 'other' option - add it into the field custom name.
            if ( isOther ) {
                if (key === "luxury_watch_brand"){
                    params.seller_item.subsets[1].properties_set[key] =  key + "_other";
                    params.seller_item.subsets[1].properties_set.luxury_watch_brand_custom_name =  details[key];
                }else{
                    let extraInfo = params.seller_item.subsets[1].properties_set.extra_info || "";
                    params.seller_item.subsets[1].properties_set.extra_info = extraInfo + " " + key + " - " + details[key];
                }
            }
            else {
                // find field to know if this is a db based field or not.
                let field = this.state.options.find(o => o.name === key)

                if ( field.dbBased === false ) {
                    params.seller_item.subsets[1].properties_set[key] = details[key]
                } else {
                    // the standard in our db is to prefix property options values with the property type value
                    params.seller_item.subsets[1].properties_set[key] = key + "_" + this.nameByText(key, details[key]).replace(/ /, "_")
                }
            }
        }

        if (!this.props.Session.isLoggedIn) {
            browserHistory.push('/register');
        } else {
            this.setState({submitFormInProcess: true});
        }

        this.props.newPendingItem(this.props.params, params, this.props.Session.isLoggedIn);
    }

    nameByText(fieldName,text) {
        if ( !text ) {
            return
        }
        let option = this.state.options.find(o => o.name === fieldName)
        if ( option && option.options) {
            let item = option.options.find(o => o.text === text)
            if (item) {
                return item.name
            }
        }
        // relevant in cases of text fields / yes|no
        return text.toLowerCase()
    }

    getOptions() {
        // need decide on the model option first.
        let modelOption = null
        if ( !this.state[formOptions.brand.name] ) {
            modelOption = formOptions.noBrandModel
        } else if ( this.isOtherBrandSelected() ){
            modelOption = formOptions.otherModel
        } else {
            modelOption = models(this.nameByText(formOptions.brand.name,this.state[formOptions.brand.name]))
        }

        // return an array of options.
        return [
            formOptions.brand,
            modelOption,
            formOptions.condition,
            formOptions.originalBox,
            formOptions.papersIncluded
        ]
    }

    onValueChanged(key, value, callback) {
        this.setState({[key]:value},() => {
            if ( key === formOptions.brand.name ) {
                this.setState({options:this.getOptions()})
                callback()
            }
            else {
                callback()
            }
        })
    }

    isOtherSelected(fieldName) {
        let field = this.state.options.find(o => o.name === fieldName)
        let selected = this.state[fieldName]

        // field can be undefined in the first load of the component.
        if ( field === undefined || !field.hasOther || !field.options || field.options.findIndex(x => x.text === selected) > -1) {
            return false
        }

        return true
    }

    isOtherBrandSelected() {
        return this.isOtherSelected(formOptions.brand.name)
    }

    render() {
        return <AccordionForm onSubmit={this.submitWatch} {...this.state}
                              onValueChanged={this.onValueChanged}
                              title={I18n.getString("submitForm::watch::title")}
                              name={"submit-watch"}
                              options={this.state.options}
                              location={this.props.location}
        />
    }
}

function models(brand) {
    let model = formOptions.brandModel
    if ( modelsByBrand[brand] ) {
        model.options = modelsByBrand[brand].map(m => {
            let str = m.charAt(0).toUpperCase() + m.toLowerCase().slice(1)
            return { name:str.toLowerCase(), text:str }
        })
    } else {
        model.options = []
    }
    return model
}

/***
 * The actual values of models and brands are retrieved from I18n. kept here for readability *
 */
let modelsByBrand = {
    // breitling:["NAVITIMER", "CHRONOMAT", "SUPEROCEAN", "AVENGER", "GALACTIC", "MONTBRILLANT", "COLT"],
    // cartier:["BALLON BLUE", "TANK", "SANTOS" , "PANTHERE" , "CHRONOSCAPH" , "PASHA" , "ROADSTER"],
    // iwc:["AQUATIMER" , "DA VINCI", "INGENIEUR", "PILOT'S WATCH", "PORTOFINO" , "PORTUGIESER"],
    // omega:["CONSTELLATION", "SEAMASTER", "SPEEDMASTER", "DE VILLE"],
    // patek_philippe:["GRAND COMPLICATIONS", "COMPLICATIONS", "CALATRAVA", "GONDOL", "NAUTILUS", "AQUANAUT", "POCKET WATCH"],
    // rolex:["DAY DATE", "DATEJUST", "OYSTER PERPETUAL", "DAYTONA", "SUBMARINER", "GMT MASTER", "CELLINI"],
    // tag_heuer:[ "CARRERA" , "AQUARACER", "MONACO" , "FORMULA 1", "LINK", "AUTOMATIC", "CHRONOGRAPH"]
}

const WATCH_ITEM_PREFIX = "common/watch_submit/"
let brandOptions = [
    // { name:"rolex",img: WATCH_ITEM_PREFIX + "rolex.png", imgSelected: WATCH_ITEM_PREFIX + "rolex_white.png", text:"Rolex"},
    // { name:"patek_philippe",img: WATCH_ITEM_PREFIX + "patek_phillippe.png", imgSelected: WATCH_ITEM_PREFIX + "patek_philippe_white.png", text: "Patek Philippe" },
    // { name:"breitling",img: WATCH_ITEM_PREFIX + "breitling.png", imgSelected: WATCH_ITEM_PREFIX + "breitling_white.png", text: "Breitling"  },
    // { name:"omega",img: WATCH_ITEM_PREFIX + "omega.png", imgSelected: WATCH_ITEM_PREFIX + "omega_white.png", text: "Omega" },
    // { name:"cartier",img: WATCH_ITEM_PREFIX + "cartier.png", imgSelected: WATCH_ITEM_PREFIX + "cartier_white.png", text: "Cartier" },
    // { name:"iwc",img: WATCH_ITEM_PREFIX + "iwc.png", imgSelected: WATCH_ITEM_PREFIX + "iwc_white.png", text: "IWC" },
    // { name:"tag_heuer",img: WATCH_ITEM_PREFIX + "tag.png", imgSelected: WATCH_ITEM_PREFIX + "tag_heuer_white.png", text: "Tag Heuer" }
]

let conditionOptions = [
    // {name:"new_in_box", text:"New in box"},
    // {name:"mint", text:"Mint"},
    // {name:"excellent", text:"Excellent"},
    // {name:"very_good", text:"Very good"},
    // {name:"fair", text:"Fair"},
    // {name:"not_working", text:"Not working"},
]


const formOptions = {
    brand:{
        name: "luxury_watch_brand",
        type: BoxedSelectList,
        options: brandOptions,
        hasOther:I18n.getString("submitForm::watch::fields::brand::hasOther") === "true",
        fillOtherOption: true,
        otherPlaceholder: I18n.getString("submitForm::watch::fields::brand::placeholder"),
        label: I18n.getString("submitForm::watch::fields::brand::label"),
        isRequired: true
    },
    brandModel: {
        name: "luxury_watch_model",
        type: BoxedSelectList,
        options: [],
        hasOther:I18n.getString("submitForm::watch::fields::model::hasOther") === "true",
        fillOtherOption: true,
        label: I18n.getString("submitForm::watch::fields::model::label"),
        dependsOn:"luxury_watch_brand",
        dbBased:false,
        isRequired: true
    },
    otherModel: {
        name: "luxury_watch_model",
        type: BoxedField,
        label: I18n.getString("submitForm::watch::fields::model::label"),
        dependsOn:"luxury_watch_brand",
        dbBased:false
    },
    noBrandModel: {
        name: "luxury_watch_model",
        type: BoxedText,
        label: I18n.getString("submitForm::watch::fields::model::label"),
        text: I18n.getString("submitForm::watch::fields::model::noBrand"),
        dependsOn:"luxury_watch_brand",
        dbBased:false
    },
    condition: {
        name: "luxury_watch_condition",
        type: BoxedSelectList,
        options: conditionOptions,
        hasOther:I18n.getString("submitForm::watch::fields::condition::hasOther") === "true",
        label: I18n.getString("submitForm::watch::fields::condition::label"),
        addClass: "oneline",
        isRequired: true
    },
    originalBox: {
        name: "luxury_watch_original_box_papers",
        type: BoxedYesNo,
        label: I18n.getString("submitForm::watch::fields::originalBox::label"),
        isRequired: true
    },
    papersIncluded: {
        name: "luxury_watch_includes_papers",
        type: BoxedYesNo,
        label: I18n.getString("submitForm::watch::fields::papersIncluded::label"),
        isRequired: true
    }
}

const preloads = [
    "breitling.png",
    "breitling_white.png",
    "cartier.png",
    "cartier_white.png",
    "iwc.png",
    "iwc_white.png",
    "omega.png",
    "omega_white.png",
    "patek_philippe.png",
    "patek_philippe_white.png",
    "rolex.png",
    "rolex_white.png",
    "tag_heuer.png",
    "tag_heuer_white.png"
]

export {SubmitWatch, watch_details}
